"use client";

import { Button, ButtonLink } from "@/components/ui/button";
import { useTriggerAction } from "@/lib/action-link";
import { bookingLabel, offersFreeConsultation } from "@/lib/consultation";
import { cn } from "@/lib/utils";
import type { ComponentProps } from "react";
import { usePublicPathname } from "@/lib/public-pathname";

type Variant = ComponentProps<typeof Button>["variant"];

export function CtaButton({
  href,
  action,
  variant,
  className,
  keepOnMobile = false,
  children,
}: {
  href?: string;
  action?: string | null;
  variant?: Variant;
  className?: string;
  keepOnMobile?: boolean;
  children: React.ReactNode;
}) {
  const trigger = useTriggerAction();
  const free = offersFreeConsultation(usePublicPathname());
  const label = typeof children === "string" ? bookingLabel(children, free) : children;
  const drawerAction = action === "open_quiz" ? "open_quiz" : "open_booking";
  const opensDrawer =
    action === "open_booking" ||
    action === "open_quiz" ||
    !href ||
    href === "#" ||
    href === "#book";

  if (!opensDrawer) {
    return (
      <ButtonLink href={href} variant={variant} className={className}>
        {label}
      </ButtonLink>
    );
  }

  return (
    <Button
      variant={variant}
      className={cn(!keepOnMobile && "max-md:hidden", className)}
      onClick={(e) => trigger(drawerAction, e)}
    >
      {label}
    </Button>
  );
}
